import React, { Component } from "react";
import BecasTabla from "./BecasTabla";
import { connect } from "react-redux";
import { getBecasList } from './BecasAction'
import { withRouter } from 'react-router-dom';

class BecasContainer extends Component {

    componentDidMount() {
        //console.log("BecasContainer");
        this.props.dispatch(getBecasList());
    }

    render() {
        return (
            <div>
                <BecasTabla />
            </div>
        );
    }

}

export default connect()(BecasContainer);
